import * as React from "react";
import { useAccount, State } from "@grandvisionhq/auth";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useFetchUserDetails } from "../../../../../../hooks/user/hooks/user/use-fetch-user-details.js";
import { useAuthToken } from "../../../../../../hooks/user/hooks/user/useAuthToken.js";
const useGetPreferredStore = () => {
  const { loadUserDetails, loading: isFetchingStoreId, userData } = useFetchUserDetails();
  const { isMyAccountEnabled } = useFeatureToggles();
  const authState = useAccount();
  const [, authTokenState] = useAuthToken();
  const authToken = authTokenState.data;
  const isLoggedIn = isMyAccountEnabled && authState === State.AuthState.LoggedIn && Boolean(authToken);
  const handleUserDetails = React.useCallback(() => {
    authToken && loadUserDetails(authToken);
  }, [loadUserDetails, authToken]);
  React.useEffect(() => {
    if (isLoggedIn) {
      handleUserDetails();
    }
  }, [isLoggedIn]);
  return React.useMemo(
    () => ({
      globalStoreId: userData?.globalStoreId || void 0,
      isFetchingStoreId
    }),
    [isFetchingStoreId, userData?.globalStoreId]
  );
};
export {
  useGetPreferredStore
};
//# sourceMappingURL=use-get-preferred-store.js.map
